import Vue from 'vue';
import Router from 'vue-router';
import Store from '@/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'ログイン',
      path: '/login',
      component: () => import('./views/common/Login.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); },
      meta: {
        isPublic: true,
      },
      props: (route) => ({ test: route.query.test || null }),
    },
    {
      name: 'ホーム',
      path: '/',
      component: () => import('./views/common/Home.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); },
    },
    {
      name: '入庫',
      path: '/agent/inbound',
      component: () => import('./views/agent/Inbound.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); },
    },
    {
      name: '発送',
      path: '/agent/shipmentplan',
      component: () => import('./views/agent/ShipmentPlan.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); },
    },
    {
      name: 'LAS登録',
      path: '/seller/item/registration',
      component: () => import('./views/seller/ItemRegistration.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); },
    },
    {
      name: '入庫状況確認',
      path: '/seller/inbound/confirmation',
      component: () => import('./views/seller/InboundConfirmation.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); }},
    {
      name: '管理品',
      path: '/common/merchandise/management',
      component: () => import('./views/common/MerchandiseManagement.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); }},
    {
      name: '分析',
      path: '/common/analysis/sales',
      component: () => import('./views/analysis/AnalysisSales.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); }},
    {
      name: '過去データ',
      path: '/common/analysis/history',
      component: () => import('./views/analysis/AnalysisHistory.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); }},
    {
      name: 'ポイント',
      path: '/common/analysis/inbound',
      component: () => import('./views/analysis/AnalysisInbound.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); }},
    {
      name: '発送請求',
      path: '/common/shipment/request',
      component: () => import('./views/common/ShipmentRequest.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); }},
    {
      name: 'インボイス',
      path: '/invoice/main',
      component: () => import('./views/invoice/InvoiceMain.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); }},
    {
      name: 'データベース',
      path: '/invoice/master/procuct',
      component: () => import('./views/invoice/InvoiceDatabase.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); }},
    {
      name: 'メーカーマスタ',
      path: '/invoice/master/maker',
      component: () => import('./views/invoice/MakerMaster.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); }},
    {
      name: 'カテゴリマスタ',
      path: '/invoice/master/category',
      component: () => import('./views/invoice/CategoryMaster.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); }},
    {
      name: 'マッピング情報',
      path: '/invoice/master/mapping',
      component: () => import('./views/invoice/MappingInfo.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); }},
    {
      name: 'デポジット',
      path: '/other/deposit',
      component: () => import('./views/other/Deposit.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); }},
    {
      name: 'SLC-US請求',
      path: '/other/slcusrequest',
      component: () => import('./views/other/SlcUsRequest.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); }},
    {
      name: 'SLC-US請求一括登録',
      path: '/other/slcusupload',
      component: () => import('./views/other/SlcUsRequestUpload.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); }},
    {
      name: 'US返品・保管品',
      path: '/other/usreturnedgoodscustody',
      component: () => import('./views/other/UsReturnedGoodsCustody.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); }},
    {
      name: '諸払',
      path: '/other/payment',
      component: () => import('./views/other/Payment.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); },
    },
    {
      name: '関税',
      path: '/other/custom',
      component: () => import('./views/other/CustomRegistration.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); },
    },
    {
      name: '請求書出力',
      path: '/other/invoice',
      component: () => import('./views/other/InvoiceOutput.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); },
    },
    {
      name: '会員情報登録',
      path: '/master/seller/registration',
      component: () => import('./views/master/SellerRegistration.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); },
    },
    {
      name: '会員情報参照',
      path: '/master/seller/list',
      component: () => import('./views/master/SellerReference.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); },
    },
    {
      name: '送料マスタ',
      path: '/master/shippingfee/list',
      component: () => import('./views/master/ShippingFee.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); },
    },
    {
      name: '管理ツール',
      path: '/master/management/changesku',
      component: () => import('./views/master/ChangeSku.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); },
    },
    {
      name: 'チャット',
      path: '/master/chatai/display',
      component: () => import('./views/master/ChatAI.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); },
    },
    {
      name: 'パスワード変更',
      path: '/account/password/change',
      component: () => import('./views/account/PasswordChange.vue'),
      beforeEnter : (to, from, next) => { dispatchEvent(new Event('hideAlert')); next(); },
    },
    {
      path: '*',
      redirect: '/',
    }
  ],
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((page) => page.meta.isPublic) || Store.state.token) {
    next();
  } else {
    next('/login');
  }
})

export default router;
